'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Months = {
    0: 'componentLib.appWide.dates.months.short.january',
    1: 'componentLib.appWide.dates.months.short.february',
    2: 'componentLib.appWide.dates.months.short.march',
    3: 'componentLib.appWide.dates.months.short.april',
    4: 'componentLib.appWide.dates.months.short.may',
    5: 'componentLib.appWide.dates.months.short.june',
    6: 'componentLib.appWide.dates.months.short.july',
    7: 'componentLib.appWide.dates.months.short.august',
    8: 'componentLib.appWide.dates.months.short.september',
    9: 'componentLib.appWide.dates.months.short.october',
    10: 'componentLib.appWide.dates.months.short.november',
    11: 'componentLib.appWide.dates.months.short.december',
};

exports.Months = Months;
